export default __webpack_public_path__ + "static/media/pageyeild.4c856b04.png";